<scitis-app-global-page-header [pageTitle]="'Analog Digital Conversion Settings'">
  <ng-template #filterElement>
    <button class="btn btn-primary" (click)="save()"
            [disabled]="buttonsDisabled()"
            [title]="'Save' | translate">
        <span>
          <span class="fa-solid fa-check"></span>
          <span translate>Save</span>
        </span>
    </button>
  </ng-template>
  <ng-template #filterElement>
    <div class="d-inline-block" ngbDropdown
         #dropdownActions="ngbDropdown"
         placement="bottom-right">
      <button class="btn btn-outline-primary"
              id="dropdownActions" ngbDropdownToggle>
        <span translate>Actions</span>
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownActions">

        <button ngbDropdownItem (click)="uploader.click()"
                [disabled]="!isAdminOrSuperAdminOrTechAdmin"
                [title]="'Import ADC configuration'|translate">
            <span>
              <span class="fa-solid fa-file-import"></span>
              <span translate>Import</span>
            </span>
          <input type="file"
                 [hidden]="true"
                 #uploader
                 [id]="'logo_'+name"
                 [accept]="'.'+jsonType"
                 (change)="onFileSelected($event)"
                 class="hidden-file-upload"/>
        </button>

        <button ngbDropdownItem (click)="onExportAdcConfig()"
                [disabled]="!isAdminOrSuperAdminOrTechAdmin"
                [title]="'Export ADC configuration'|translate">
            <span>
              <span class="fa-solid fa-file-export"></span>
              <span translate>Export</span>
            </span>
        </button>

        <button ngbDropdownItem (click)="pushToIoTCore()"
                [disabled]="buttonsDisabled()"
                [title]="'Transfer configuration' | translate">
          <span class="fa-solid fa-cloud-arrow-up"></span>
          <span translate>Transfer configuration</span>
        </button>

      </div>
    </div>
  </ng-template>
</scitis-app-global-page-header>


<div class="card mb-3">
  <form [formGroup]="adcForm" *ngIf="formGenerated">
    <div class="card-body">

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label translate>Sample rate</label>
            <div class="input-group">
              <input name="sampleRate" type="number" formControlName="sampleRate" class="form-control"
                     (focusout)="onFocusOut()"
                     [ngClass]="{'is-invalid': formControls.sampleRate.errors}"/>
              <div class="input-group-append">
                <span class="input-group-text">ms</span>
              </div>
              <div *ngIf="formControls.sampleRate.errors" class="invalid-feedback">
              <span
                  *ngIf="formControls.sampleRate.errors.min || formControls.sampleRate.errors.max || formControls.sampleRate.errors.required"
                  translate>Sample rate needs to be between 100 and 60000</span>
              </div>
            </div>

          </div>

        </div>
      </div>

      <hr>

      <div class="row align-items-center mb-2">
        <div class="col">
          <span class="h5 mb-0" translate>Signals</span>
        </div>
        <div class="col-auto">
          <button aria-label="add signal" class="btn btn-primary"
                  (click)="addSignal()" title="Add signal"
                  [disabled]="isAddSignalDisabled()">
            <span class="fa-solid fa-plus" aria-hidden="true"></span>
            <span translate>Add signal</span>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-4" *ngFor="let adc of settings.values">

          <scitis-admin-gateway-adc-setting
              [adc]="adc"
              [availableIndices]="availableIndices"
              (removeSettingChangeEvent)="removeSetting($event)"
              (changeIndexEvent)="changeIndex($event)"
              (formIsValid)="onCheckFormsValidation($event)">
          </scitis-admin-gateway-adc-setting>

        </div>
      </div>

    </div>
  </form>
</div>
